/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FxIdWebFeaturesAnalyticsTrackRequest,
} from '../models/index';
import {
    FxIdWebFeaturesAnalyticsTrackRequestFromJSON,
    FxIdWebFeaturesAnalyticsTrackRequestToJSON,
} from '../models/index';

export interface FxIdWebFeaturesAnalyticsTrackEndpointRequest {
    fxIdWebFeaturesAnalyticsTrackRequest: FxIdWebFeaturesAnalyticsTrackRequest;
}

/**
 * 
 */
export class AnalyticsApi extends runtime.BaseAPI {

    /**
     * Tracks analytics events  
     */
    async fxIdWebFeaturesAnalyticsTrackEndpointRaw(requestParameters: FxIdWebFeaturesAnalyticsTrackEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fxIdWebFeaturesAnalyticsTrackRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAnalyticsTrackRequest',
                'Required parameter "fxIdWebFeaturesAnalyticsTrackRequest" was null or undefined when calling fxIdWebFeaturesAnalyticsTrackEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/analytics/track`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAnalyticsTrackRequestToJSON(requestParameters['fxIdWebFeaturesAnalyticsTrackRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Tracks analytics events  
     */
    async fxIdWebFeaturesAnalyticsTrackEndpoint(fxIdWebFeaturesAnalyticsTrackRequest: FxIdWebFeaturesAnalyticsTrackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fxIdWebFeaturesAnalyticsTrackEndpointRaw({ fxIdWebFeaturesAnalyticsTrackRequest: fxIdWebFeaturesAnalyticsTrackRequest }, initOverrides);
    }

}
